export default __webpack_public_path__ + "static/media/2829 cutlery side.05e3e966.png";